import React, { useState } from "react";
import CopyIcon from "../Assets/svgs/CopyIcon";
import { copyToClipboard } from "./utils";
import { Tooltip } from "@mui/material";

const CopyBox = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const onClickCopy = () => {
    copyToClipboard(text);
    setIsCopied(true);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 2000);
  };

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: "#f4f0ff",
        borderRadius: "6px",
        padding: "0px 0px 0px 12px",
        fontFamily: "sans-serif",
        marginTop: "4px",
      }}
    >
      <span
        style={{
          marginRight: "8px",
          fontSize: "14px",
          color: "#5b3cc4",
          fontWeight: "500",
        }}
      >
        ID: {text}
      </span>
      <Tooltip
        title={isCopied ? "Copied" : "Copy"}
        placement="top"
        arrow
        open={open}
      >
        <div
          style={{
            backgroundColor: "#a274f7",
            padding: "8px",
            borderTopRightRadius: "6px",
            borderBottomRightRadius: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          onClick={onClickCopy}
        >
          <CopyIcon color="#fff" />
        </div>
      </Tooltip>
    </div>
  );
};

export default CopyBox;
